var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTemplateAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65376 3.55783C1.65376 2.23874 2.33713 1.55597 3.63554 1.55597H7.72665V1.43985C7.72665 0.483047 7.24374 0 6.29613 0H1.43052C0.473804 0 0 0.483047 0 1.43985V6.32606C0 7.28751 0.473804 7.76591 1.43052 7.76591H1.65376V3.55783ZM3.70387 10H8.56948C9.52164 10 10 9.5216 10 8.56479V3.6275C10 2.67069 9.52164 2.18765 8.56948 2.18765H3.70387C2.75171 2.18765 2.27335 2.67069 2.27335 3.6275V8.56479C2.27335 9.5216 2.75171 10 3.70387 10ZM6.14579 8.18393C5.93622 8.18393 5.77221 8.01208 5.77221 7.77984V6.48862H4.49203C4.28246 6.48862 4.09112 6.30283 4.09112 6.08918C4.09112 5.88481 4.28246 5.69438 4.49203 5.69438H5.77221V4.4078C5.77221 4.18021 5.93622 4.00836 6.14579 4.00836C6.35535 4.00836 6.52392 4.18021 6.52392 4.4078V5.69438H7.7631C7.99544 5.69438 8.18223 5.87552 8.18223 6.08918C8.18223 6.30748 7.99544 6.48862 7.7631 6.48862H6.52392V7.77984C6.52392 8.01208 6.35535 8.18393 6.14579 8.18393Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTemplateAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-template-add.0be12f00bd054aa186490a96760a243c.svg";